jQuery(document).ready(function($) {

    // Sticky navigation
    const sticky = $('#stickyNav');
    const stickyOffset = sticky.offset().top;

    $(window).scroll(function() {
        if ($(window).scrollTop() >= stickyOffset) {
            sticky.addClass('fixed');
        } else {
            sticky.removeClass('fixed');
        }
    });

    $('.mega-menu-toggle').on('click', function() {
        if (!$('#menu-jh-masthead-clone').length) {
            // Clone #menu-jh-masthead and change its ID
            const clonedMenu = $('#menu-jh-masthead').clone().attr('id', 'menu-jh-masthead-clone');
            // Append the cloned menu to #mega-menu-jh-header-mega-menu
            $('#mega-menu-jh-header-mega-menu').append(clonedMenu);
        }
    });

});
